import { formatDate } from "date-fns";

export const formatCustomDate = (date) => {
  return formatDate(date, "MMM dd, yyyy");
};

export const formatCustomDateTime = (dateTime) => {
  return formatDate(dateTime, "MMM dd, yyyy h:mm a");
};

export const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const formatNumber = (num, decimalPlaces) => {
  const number = parseFloat(num);

  if (isNaN(number)) {
    return "0";
  }

  return parseFloat(num.toFixed(decimalPlaces)); // convert it back to a number to remove trailing zeros after the decimal
};
